import { render } from "./PhysicalOrders.vue?vue&type=template&id=a0d45ee6&scoped=true"
import script from "./PhysicalOrders.vue?vue&type=script&lang=js"
export * from "./PhysicalOrders.vue?vue&type=script&lang=js"

import "./PhysicalOrders.vue?vue&type=style&index=0&id=a0d45ee6&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0d45ee6"]])

export default __exports__